import React from "react";
import { observer } from "mobx-react";
import { WeaRichText } from "ecCom";

@observer
export default class RichTextItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaRichText
        ecId={`${this.props.ecId}_WeaRichText@rgvbsi`}
        {...bindObj.bind()}
        onChange={this.onChange}
        {...c}
        {...c.otherParams}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/RichTextItem.js